import { useQuery, UseQueryResult } from "react-query";
import Request from "v2/domain/benefitRequest/entities/Request";
import findBenefitRequestDetail from "v2/domain/benefitRequest/useCases/findBenefitRequestDetail";

export default function useBenefitRequestDetail({
  companyId,
  requestId,
}: {
  companyId: string;
  requestId: string;
}): UseQueryResult<Request, Error> {
  return useQuery<Request, Error>(
    ["companyBenefitRequestDetail", `${companyId}/${requestId}`],
    () => findBenefitRequestDetail({ companyId, requestId })
  );
}
